import { Loader2, TriangleAlert } from "lucide-react";

import { formatCurrency } from "@/lib/utils";

import { Button } from "../ui/button";
import { DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "../ui/dialog";

export function ConfirmPayment({ label, fee, isPending, total, state, courierBranchName, handlePayment }: {
	label: string;
	fee: {
		intasida: number;
		courier: number;
	};
	isPending: boolean;
	total: number;
	state: string;
	courierBranchName: string;
	courierBranchAddress: string;
	handlePayment: () => void;
}) {
	return (
		<>

			<DialogHeader className="flex-row items-start justify-between space-y-0">
				<DialogTitle>{label}</DialogTitle>
			</DialogHeader>
			<DialogDescription>
				<span className="bg-hover-secondary flex rounded-lg w-full items-center justify-center">
					<TriangleAlert className="size-4 text-primary font-light" />
					<span className="text-center py-4 px-2 text-xs text-primary" role="alert">
						Kindly review the information below before proceeding
					</span>
				</span>
			</DialogDescription>

			<div>
				<div className="flex justify-between">
					<div className="flex justify-between flex-1">
						<span className="text-muted-foreground">State:</span>
						<span>{state}</span>
					</div>
				</div>
				<div className="flex justify-between gap-2 flex-wrap w-full">
					<span className="text-muted-foreground">Courier service:</span>
					<span className="text-sm">{courierBranchName}</span>
				</div>
			</div>
			<div className="my-auto">
				<div className="flex justify-between text-xs">
					<span className="text-muted-foreground">Intasida:</span>
					<span>{formatCurrency(fee.intasida, "NGN")}</span>
				</div>
				<div className="flex justify-between text-xs">
					<span className="text-muted-foreground">Courier Fee:</span>
					<span>{formatCurrency(fee.courier, "NGN")}</span>
				</div>
				<div className="flex justify-between *:text-xs">
					<span className="text-muted-foreground">Amount:</span>
					<span>{formatCurrency(total, "NGN")}</span>
				</div>
				<div className="flex justify-between">
					<span className="text-muted-foreground">Total Amount:</span>
					<span>{formatCurrency(total + fee.courier + fee.intasida, "NGN")}</span>
				</div>
			</div>

			<DialogFooter>
				<DialogTrigger
					disabled={isPending}
					asChild
				>
					<Button
						className="w-full"
						disabled={isPending}
						onClick={handlePayment}
					>
						{isPending
							? (
									<>
										<Loader2 size={20} className="animate-spin" />
										{" "}
                                                &nbsp; Loading....
									</>
								)
							: (
									"Confirm"
								)}

					</Button>
				</DialogTrigger>
			</DialogFooter>
		</>
	);
}
